module.exports = __webpack_public_path__ + "static/media/grafismo-ranking.0fcfce33.png";